import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import { RoomDetailJson } from '../typings';

// 加入房间
interface JoinroomData {
  fromType: number;
  htmlFlag?: number;
  roleId?: number;
  roomId: number;
  sdkJoin?: number;
  showRoomId?: string;
  specialJoin?: number;
  userId: number;
  withoutReturn?: boolean;
  password?: string;
  isMain?: boolean;
  live_platform?: string;
}

export function joinroom(data: JoinroomData) {
  return request<RoomDetailJson>({
    method: 'POST',
    url: httpApi.voice.joinroom,
    data
  });
}

// 获取房间信息
interface RoomDetailParams {
  fromType: number;
  roomId: number;
  userId: number;
  isMain?: boolean;
  live_platform?: string;
  quitType?: string;
}

export function getRoomDetail(params: RoomDetailParams) {
  return request<RoomDetailJson>({
    method: 'GET',
    url: httpApi.voice.roomDetail,
    params
  });
}

// 离开房间
export function leaveroom(params: RoomDetailParams) {
  return request({
    method: 'GET',
    url: httpApi.voice.leaveroom,
    params
  });
}

// 根据外显id获取房间id
interface IdByShowRoomParams {
  showRoomId: number;
  live_platform?: string;
}

export function idByShowRoom(params: IdByShowRoomParams) {
  return request<number>({
    method: 'GET',
    url: httpApi.voice.idByShowRoom,
    params
  });
}

// 房间信息搜索
interface FindRandomLiveRoomParams {
  roomId: number;
  live_platform?: string;
}

interface FindRandomLiveRoomJson {
  roomId: number;
  roomType: number;
}

export function findRandomLiveRoom(params: FindRandomLiveRoomParams) {
  return request<FindRandomLiveRoomJson>({
    method: 'GET',
    url: httpApi.voice.findRandomLiveRoom,
    params
  });
}

interface GetOssSignParams {
  dirName: string;
  live_platform?: string;
}

export interface OssSignJson {
  accessid: string;
  host: string;
  policy: string;
  signature: string;
  expire: number;
  dir: string;
  bucket: string;
}

// 获取oss临时上传参数
export function getOssSign(params: GetOssSignParams) {
  return request<OssSignJson>({
    method: 'GET',
    url: httpApi.voice.getOssSign,
    params
  });
}

export interface HallEnterRoomJson {
  collect: number;
  mainRoomId: number;
  roomId: number;
  isMain: boolean;
  showRoomId: number;
  livePlatform?: string;
  collectType?: number;
}
